import { Settings } from '@otp/icons';
import { Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import {
  Actions,
  AppArea,
  Subjects,
  User,
} from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';
import { UserImpersonateCard } from './user-impersonate-card';
import { UserAccessToggleCard } from './user-access-toggle-card';
import { UserEditAction } from 'src/components/organisation/manage-otps/user-details/user-edit-action';
import { useCan } from 'src/utils/can';

type UserActionsProps = {
  user: Partial<User>;
};

export const UserActions = ({ user }: UserActionsProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-otps.actions',
  });
  const { can } = useCan();
  const canEditProfile =
    can({
      action: Actions.Write,
      appArea: AppArea.Common,
      subject: Subjects.Users,
    }) ||
    can({
      action: Actions.Write,
      appArea: AppArea.Admin,
      subject: Subjects.Users,
    });

  return (
    <>
      <Typography variant="subtitle1" className="pt-4 flex">
        <Settings className="pr-2" />
        {t('title')}
      </Typography>
      {canEditProfile && (
        <div className="mt-2">
          <UserEditAction user={user} />
        </div>
      )}
      <Can I={Actions.Write} a={Subjects.Impersonate} appArea={AppArea.Admin}>
        <div className="mt-2">
          <UserImpersonateCard user={user} />
        </div>
      </Can>
      <UserAccessToggleCard user={user} className="mt-2" />
    </>
  );
};
